(function () {
    'use strict';

    angular
        .module('emails')
        .controller('tokenLetterModalController', tokenLetterModalController);

    tokenLetterModalController.$inject = ['$uibModalInstance', 'CampaignsService', 'event'];

    function tokenLetterModalController($uibModalInstance, CampaignsService, event) {
        var vm = this;
        vm.letterTypeSelected = {};
        vm.letterTypeList = [
            {name: 'Event Open', template: 'token'},
            {name: 'Last 2 Hours', template: 'token2hours'},
            {name: 'Last 60 minutes', template: 'tokenLastChance'},
        ];
        vm.registrationTypeSelected = {};
        vm.registrationTypeList = [
            {id:'all', name: 'All',},
            {id:'2', name: 'With sessions'},
            {id:'1', name: 'Confirmed'},
            {id:'0', name: 'Pending'},
        ];
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.sendToCronQueue = sendToCronQueue;
        vm.event           = event;

        activate();

        function activate() {
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function sendToCronQueue() {
            vm.data = {};
            vm.data = {
                expo_id: event.expo_id,
                letter_type: vm.letterTypeSelected.template,
                registration_type: vm.registrationTypeSelected.id
            }
            CampaignsService.sendTokenLetter(vm.data).then(function(response){
                alertify.notify('Token letters sent successfully!', 'success', 3);
                vm.letterTypeSelected = {};
                vm.registrationTypeSelected = {};
                vm.cancel();
            }).catch(function(err) {
                alertify.notify('Sorry! An error has occurred!', 'error', 3);
            });
        }

    }

})();